
import Vue from "vue";
import { getAgeFromBirthDate } from "@/helper/utils/dateUtils";
import {
  Sex,
  SexTypes,
  getIsDrinkTypeSelects,
  getIsSmokeTypeSelects,
  getBloodTypeSelects,
  SceneType,
  SceneTypes,
} from "@/types/abstract";
import { prefecture_list } from "@/helper/constants";
import { storage } from "@/plugins/firebase";
import { route_home } from "@/router";
import { IGuest, initGuest } from "@/types/guest";
import { GuestApi } from "@/adapter/guestApi";
import UserImgListCard from "@/components/parts/UserImgListCard.vue";
import GuestImageUpdateDialog from "@/components/parts/GuestImageUpdateDialog.vue";
import { getDownloadURL, ref } from "firebase/storage";
export default Vue.extend({
  components: {
    GuestImageUpdateDialog,
    UserImgListCard,
  },
  data(): {
    prefectureItems: string[];
    isDrinkItems: string[];
    isSmokeItems: string[];
    bloodTypeItems: string[];
    activePicker: string | null;
    date: string | null;
    birthDateMenu: boolean;
    imgSrcUrl: string;
    errMsg: string;
    sceneTagItems: SceneType[];
    userInfoData: IGuest;
    imgMsg: string;
  } {
    return {
      prefectureItems: prefecture_list,
      isDrinkItems: getIsDrinkTypeSelects(),
      isSmokeItems: getIsSmokeTypeSelects(),
      bloodTypeItems: getBloodTypeSelects(),
      activePicker: null,
      date: null,
      birthDateMenu: false,
      imgSrcUrl: "",
      errMsg: "",
      sceneTagItems: Object.values(SceneTypes),
      userInfoData: initGuest,
      imgMsg: "",
    };
  },
  watch: {
    birthDateMenu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    userInfoData: {
      handler: async function(value) {
        if (!value.imgSrcList[0]) {
          this.imgSrcUrl = "";
          return;
        }
        const url = await getDownloadURL(ref(storage, value.imgSrcList[0]))
          .then(function(url) {
            return url;
          })
          .catch(function(error) {
            console.log(error);
            return "";
          });

        this.imgSrcUrl = url;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    save(date: string) {
      (this.$refs as any).menu.save(date);
      let age = getAgeFromBirthDate(date);
      this.userInfoData.age = age.toString();
    },
    isMan(sex: Sex): boolean {
      return sex == SexTypes.Man;
    },
    isWoman(sex: Sex): boolean {
      return sex == SexTypes.Woman;
    },
    uploadedImg(imgSrcList: string[]) {
      this.userInfoData.imgSrcList = imgSrcList;
      this.imgMsg = "プロフィール画像の変更が完了しました！";
    },
    openDialog() {
      this.imgMsg = "";
      (this.$refs as any).updateImg.openDialog(this.userInfoData.imgSrcList);
    },
    async updateUserProfile() {
      // todo: バリデーション
      if (!this.validateProfile()) {
        return;
      }
      const guests = new GuestApi();
      await guests.setGuestData(this.userInfoData).then(() => {
        this.$store.dispatch("userData/setUserData", this.userInfoData);
      });
      this.$router.push(route_home);
    },
    validateProfile(): boolean {
      this.errMsg = "";
      if (this.userInfoData.name.length == 0) {
        this.errMsg = "ニックネームを入力してください。";
        return false;
      }
      if (this.userInfoData.name.length > 8) {
        this.errMsg = "ニックネームは8文字以内にしてください。";
        return false;
      }
      if (!this.userInfoData.birthDate) {
        this.errMsg = "生年月日を入力してください。";
        return false;
      }
      if (
        !Number(this.userInfoData.age) ||
        Number(this.userInfoData.age) < 18
      ) {
        this.errMsg = "18歳未満の方は登録できません。";
        return false;
      }
      return true;
    },
    closeSceneTag(item: SceneType) {
      const newArray = this.userInfoData.sceneTag.filter((n) => n !== item);
      this.userInfoData.sceneTag = newArray;
    },
  },
  async created() {
    const guests = new GuestApi();
    await guests.getUserInfo().then((res) => {
      if (res.data == null) {
        // 想定外
        return;
      }
      this.userInfoData = res.data;
    });
  },
});
